<template lang='pug'>
.container(@click="modal_close")
  .row.mt-5.align-items-center
    .col-12.my-header.font-weight-bold Лицевой счёт
    .col-12.header-sub.pr-0

  .row.mt-5
    .col-12.col-sm-6
      .account.white_block
        .row
          .col-sm-7.my-auto
            .balance(type="real")
              span.label Рублёвый счёт:
              span.value {{ balance.real }} ₽
            .balance(type="bonus")
              span.label Бонусный счёт:
              span.value {{ balance.bonus }}
          //- .col-sm-5
          //-   button.pay-submit-btn.text-center.ml-auto.py-3(
          //-     @click="modal_toggle",
          //-     :disabled="!this.payment_attributes.can_pay"
          //-   ) Пополнить
          //-     i.fas.fa-sort-down
          //-   .refill_window(:class="{ show: this.show_modal.pay_types }")
          //-     button.styled.refill(type="bill", @click="pay_with_bill") 
          //-       <i class="fal fa-money-check-edit-alt"></i> 
          //-       | Платежом по счёту
          //-     button.styled.refill(type="card", @click="pay_with_card") 
          //-       <i class="fas fa-credit-card"></i> 
          //-       | Банковской картой
          //-     button.styled.refill(type="asAdmin", @click="pay_with_admin") 
          //-       i.fas.fa-crown
          //-       | Начислить
    .col-12.col-sm-6
      .row
        .message(:class="{ show: !this.payment_attributes.contract_signed }")
          b Договор не подписан.
          br
          | К сожалению, Вы пока не можете пополнить счёт личного кабинета.
          br
          | Вы можете получить и подписать его на странице
          router-link(to="/account") Аккаунта
          | .

  .row.mt-5
    .col-sm-8
      .header-sub.mb-2 Транзакции по дням
      .table
        .not_found(v-if="this.day_transactions.length == 0")
          | ¯\_(ツ)_/¯
          br
          | Здесь пока пусто.
        .row
          .col-2.text-left Дата
          .col-4.text-center Списания
          .col-4.text-center Пополнения
          .col-2.text-right Сумма
        .row.transaction(v-for="trans in day_transactions")
          .col-2.text-left {{ trans.date }}
          .col-2.p-0.text-center.red_transaction {{ `${trans.sum_real} ₽` }}
          .col-2.p-0.text-center.red_transaction {{ `${trans.sum_bonus} бон.` }}
          .col-2.p-0.text-center.green_transaction {{ `${trans.sum_plus_real} ₽` }}
          .col-2.p-0.text-center.green_transaction {{ `${trans.sum_plus_bonus} бон.` }}
          .col-2.pl-0.text-right {{ `${trans.sum} ед.` }}
    .col-sm-4
      .header-sub.mb-2 Траты по месяцам
      .table(
        v-bind:class="{ multiple_rows: this.monthly_spending.length > 1 }"
      )
        .not_found(v-if="this.monthly_spending.length == 0")
          | ¯\_(ツ)_/¯
          br
          span(v-show="this.day_transactions.length==0") ... и здесь тоже.
          span(v-show="this.day_transactions.length!=0") Здесь пока пусто.
        .row.spending(v-for="ms in monthly_spending")
          .col.text-center 
            .month {{ ms.name }}
            .year {{ ms.year }}
          .col.text-left {{ ms.amount }} {{ ms.currency }}
            br 
            | {{ ms.bonus_amount }} бон.
    //- .col-sm-3
    //-   .header-sub.mb-2 Акты
    //-   .table(v-bind:class="{ multiple_rows: this.acts.length > 1 }")
    //-     .not_found(v-if="this.acts.length == 0")
    //-       | ¯\_(ツ)_/¯
    //-       br
    //-       span(v-show="this.day_transactions.length!=0") Пока нет актов.
    //-         br
    //-         | Акты генерируются автоматически 1 числа каждого месяца.
    //-         br
    //-         br
    //-         | В акте размещена информация по тратам в предыдущий месяц, если они были в рублях.
    //-     .row.act(v-for="act in acts")
    //-       .col.text-left
    //-         .number Акт №{{ act.act_number }}
    //-         .dates {{ act.dateStart }}
    //-           i.fal.fa-arrow-right
    //-           | {{ act.dateEnd }}
    //-         .download
    //-           a(:href="act.pdf", target="_blank")
    //-             button.styled Скачать акт

  modal.set_payment_amount(
    name="payment_set_amount_window",
    v-bind:class="{ loading: payment_constructor.loading }",
    height="auto",
    width="600",
    :adaptive="true"
  ) 
    .container
      .row
        .col
          h2 Пополнение
          .content(v-if="payment_constructor.user_type == 'user'")
            span.label Способ пополнения:
            span.value {{ payment_constructor.type == 'bill' ? 'счётом на юридическое лицо' : 'банковской картой' }}
            br
            br
            .label Сумма пополнения:
            input.payment_sum_input(
              type="number",
              ref="payment_sum_input",
              placeholder="Введите сумму пополнения",
              v-model="payment_constructor.amount",
              v-on:keyup.enter="continue_payment"
            )
            .refillBonus(v-if="payment_constructor.type == 'card'")
              | После пополнения картой, Вы получите {{ success_payment.rules.filter((l) => l[0] <= payment_constructor.amount).slice(-1)[0][1] * 100 }}% бонусами ({{ parseInt(success_payment.rules.filter((l) => l[0] <= payment_constructor.amount).slice(-1)[0][1] * payment_constructor.amount) }} бон.).
            .bonusRules(v-show="payment_constructor.type==\"card\"")
              | Напоминаем плавила начисления бонусов при оплате банковской картой:
              ul
                li(
                  v-for="r in success_payment.rules",
                  :class="{ currentRule: r[1] == success_payment.rules.filter((l) => l[0] <= payment_constructor.amount).slice(-1)[0][1] }"
                ) От {{ r[0] }} руб. начисляется {{ r[1] * 100 }}% бонусами от суммы пополнения.
            button.go_refill.styled(@click="this.continue_payment") Продолжить
          .content(v-if="payment_constructor.user_type == 'admin'")
            .label Сумма пополнения:
            input.payment_sum_input(
              type="number",
              ref="payment_sum_input",
              placeholder="Введите сумму пополнения",
              v-model="payment_constructor.amount",
              v-on:keyup.enter="continue_payment"
            )
            br
            .label Что пополняем:
            select(v-model="payment_constructor.amount_type")
              option(value="bonus") Бонусы
              option(value="real") Рубли
            button.go_refill.styled(@click="this.continue_payment") Продолжить
          .loader_holder
            object(type="image/svg+xml", data="/assets/loaders/infinity.svg")

  modal.success_payment(
    name="success_payment",
    height="auto",
    :adaptive="true"
  ) 
    .close(@click="$modal.hide('success_payment')")
      i.fal.fa-times
    .container
      .row
        .col
          h2 Успешное пополнение!
          .content
            .amountText Пополнение на сумму
              b {{ success_payment.amount }} {{ declOfNum(success_payment.amount, ['рубль', 'рубля', 'рублей']) || 'руб.' }}
            .bonusText Вам {{ declOfNum(success_payment.bonus, ['начислен', 'начислено', 'начислено']) || 'начислено' }} {{ success_payment.bonus }} {{ declOfNum(success_payment.bonus, ['бонус', 'бонуса', 'бонусов']) || 'бонусов' }} за пополнение банковской картой!
            .bonusRules
              | Напоминаем плавила начисления бонусов:
              ul
                li(
                  v-for="r in success_payment.rules",
                  :class="{ currentRule: r[1] == success_payment.current_rule }"
                ) От {{ r[0] }} руб. начисляется {{ r[1] * 100 }}% бонусами от суммы пополнения.
</template>
<script>
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import apiDriver from "../apiDriver";
import { moment } from "fullcalendar";

export default {
  data() {
    return {
      default_currency: "руб.",

      balance: {
        real: "...",
        bonus: "...",
      },

      transactions: [],
      day_transactions: [],
      monthly_spending: [],

      payment_attributes: {
        paid_before: false,
        contract_signed: false,
        can_pay: false,
        card_payment: false,
        legal_entity: false,
      },

      show_modal: {
        pay_types: false,
      },

      payment_constructor: {
        loading: false,
        amount: 0,
        type: undefined,
        save_card_payment: false,
        fast_bank_cards: [],
        user_type: "user",
        amount_type: "real",
      },

      success_payment: {
        show: false,
        amount: 0,
        bonus: 0,
        rules: [
          [0, 0.01],
          [3000, 0.05],
          [6000, 0.1],
          [10000, 0.2],
          [20000, 0.3],
          [50000, 0.5],
        ],
        current_rule: 0,
      },

      acts: [],
    };
  },

  computed: {},

  mounted() {
    this.refresh_balances();
    this.refresh_transactions();
    this.refresh_payments_attributes();
    this.getActs();

    if (document.location.search.includes("success_payment=")) {
      this.success_payment.show = true;
      this.success_payment.amount = parseInt(
        document.location.search
          .slice(1)
          .split("&")
          .find((x) => x.includes("success_payment"))
          .split("=")[1] / 100
      );
      this.success_payment.current_rule = this.success_payment.rules
        .filter((l) => l[0] <= this.success_payment.amount)
        .slice(-1)[0][1];
      this.success_payment.bonus = parseInt(
        this.success_payment.current_rule * this.success_payment.amount
      );
      this.$modal.show("success_payment");
    }
  },

  methods: {
    select_fast_card(fast_card) {
      if (!fast_card) return;
      let current = fast_card.selected;
      for (let c of this.payment_constructor.fast_bank_cards)
        c.selected = false;
      fast_card.selected = !current;
      this.$forceUpdate();
      if (this.payment_constructor.fast_bank_cards.find((x) => x.selected))
        this.payment_constructor.save_card_payment = false;
    },
    modal_open: function (e) {
      this.show_modal.pay_types = true;
    },
    modal_close: function (e) {
      this.show_modal.pay_types = false;
    },
    modal_toggle: function (e) {
      e.stopPropagation();
      if (this.show_modal.pay_types) {
        this.modal_close();
      } else {
        this.modal_open();
      }
    },

    refill: () => {
      swal({
        title: "Пополнение",
        text: "Пожалуйста, укажите сумму пополнения:",
        type: "question",
      });
    },

    async refresh_balances() {
      var balances = await apiDriver.transactions.available();
      this.balance = balances;
      this.balance.bonus =
        this.balance.bonus +
        " " +
        declOfNum(this.balance.bonus, ["бонус", "бонуса", "бонусов"]);
    },

    async refresh_transactions() {
      var transactions = await apiDriver.transactions.list();
      for (var t of transactions) {
        t.date = moment(t.createdAt).format("MM.DD");
        t.describe = t.amount < 0 ? "Оплата" : "Пополнение";
        t.operation = t.amount < 0 ? "withdraw" : "refill";
        t.currency = t.type == "real" ? this.default_currency : "бон.";

        var date_id = moment(t.createdAt).format("YYYY-MM");
        var m_spending = this.monthly_spending.find(
          (x) => x.date_id == date_id
        );
        if (!m_spending) {
          m_spending = {
            date_id,
            name: moment(t.createdAt).format("MMMM"),
            amount: 0,
            bonus_amount: 0,
            year: moment(t.createdAt).format("YYYY"),
            currency: this.default_currency,
          };
          this.monthly_spending.push(m_spending);
        }
        if (t.amount < 0) {
          var spent_amount = Math.abs(t.amount);
          if (t.type == "real") m_spending.amount += spent_amount;
          if (t.type == "bonus") m_spending.bonus_amount += spent_amount;
        }
      }

      let day_transactions = [];
      for (let t of transactions) {
        t.year = moment(t.createdAt).format("YYYY");
        let find = day_transactions.find(
          (x) => x.date == t.date && x.year == t.year
        );
        if (!find) {
          day_transactions.push({
            date: t.date,
            human_date: "",
            sum: 0,
            sum_real: 0,
            sum_bonus: 0,
            sum_plus_real: 0,
            sum_plus_bonus: 0,
            transactions: [],
            year: moment(t.createdAt).format("YYYY"),
          });
          find = day_transactions.find(
            (x) => x.date == t.date && x.year == t.year
          );
        }

        find.transactions.push(t);
        // if (t.operation == "refill") continue;
        if (t.operation == "refill") {
          if (t.type == "real") find.sum_plus_real += parseInt(t.amount);
          if (t.type != "real") find.sum_plus_bonus += parseInt(t.amount);
          find.sum += parseInt(t.amount);
          if (!find.human_date)
            find.human_date = moment(t.createdAt).format("DD MMMM");
        } else if (t.operation == "withdraw") {
          if (t.type == "real") find.sum_real += parseInt(t.amount);
          if (t.type != "real") find.sum_bonus += parseInt(t.amount);
          find.sum += parseInt(t.amount);
          if (!find.human_date)
            find.human_date = moment(t.createdAt).format("DD MMMM");
        } else {
          continue;
        }
      }

      this.day_transactions = day_transactions;
      this.transactions = transactions;
    },

    async refresh_payments_attributes() {
      var contract = this.$store.state.userData.documents.contract; //await apiDriver.documents.contract();
      var legal_entity = this.$store.state.userData.documents.legal_entity; //await apiDriver.documents.contract();
      //   var first_payment = await apiDriver.transactions.is_real_paid_already();
      if (contract.contract) {
        if (contract.signed) {
          this.payment_attributes.contract_signed = contract.signed;
        }
        if (legal_entity.legal_entity) {
          this.payment_attributes.legal_entity = legal_entity.legal_entity;
        }
        if (contract.signed && legal_entity.legal_entity) {
          this.payment_attributes.can_pay = true;
        }
      }
      this.payment_constructor.fast_bank_cards = (
        await apiDriver.payments.get_fast_bank_cards()
      ).fast;
      for (let c of this.payment_constructor.fast_bank_cards) {
        c.selected = false;
      }
    },

    pay_with_bill() {
      console.log("pay_with_bill");
      this.payment_constructor.user_type = "user";
      this.payment_constructor.loading = false;
      this.payment_constructor.type = "bill";
      this.payment_constructor.amount = 500;
      this.$modal.show("payment_set_amount_window");
      setTimeout(() => {
        this.$refs.payment_sum_input.focus();
      }, 100);
      //   apiDriver.payments.get_bill();
      // swal({
      //   type: "success",
      //   header: "Счет готов",
      //   html:
      //     "Сейчас начнётся загрузка счёта в формате .pdf<hr>Если загрузка не началась, <a href='#' target='_blank'>нажмите сюда</a>"
      // });
    },

    pay_with_card() {
      console.log("pay_with_card");
      this.payment_constructor.loading = false;
      this.payment_constructor.type = "card";
      this.payment_constructor.amount = 500;
      this.payment_constructor.save_card_payment = false;
      for (let c of this.payment_constructor.fast_bank_cards)
        c.selected = false;
      this.$modal.show("payment_set_amount_window");
      setTimeout(() => {
        this.$refs.payment_sum_input.focus();
      }, 100);
    },

    pay_with_admin() {
      console.log("pay_with_admin");
      this.payment_constructor.user_type = "admin";
      this.payment_constructor.loading = false;
      this.payment_constructor.type = "bill";
      this.payment_constructor.amount = 100;
      this.$modal.show("payment_set_amount_window");
      setTimeout(() => {
        this.$refs.payment_sum_input.focus();
      }, 100);
    },

    openInNewTab(url) {
      var win = window.open(url, "_blank");
      win.focus();
    },

    async continue_payment() {
      if (this.payment_constructor.amount <= 0) return;
      if (this.payment_constructor.user_type == "admin")
        return this.payAsAdmin();
      this.payment_constructor.loading = true;
      if (this.payment_constructor.type == "bill") {
        var bill = await apiDriver.payments.get_bill(
          this.payment_constructor.amount
        );
        if (bill) {
          var file = bill.pdf.upload.Location;
          this.$modal.hide("payment_set_amount_window");
          console.log("got bill file:", file);
          swal({
            type: "success",
            header: "Счет готов",
            html:
              "Оплатите счёт от имени юридического лица, указанного в договоре. <br><br><a href='" +
              file +
              "' target='_blank'>Скачать счёт</a> <hr> Хорошего дня :)",
          });
        }
      }
      if (this.payment_constructor.type == "card") {
        let save_card_payment = this.payment_constructor.save_card_payment;
        let selected_fast_card = this.payment_constructor.fast_bank_cards.find(
          (x) => x.selected
        );
        if (selected_fast_card) {
          // быстрая оплата выбранной картой
          var charge = await apiDriver.payments.fast_bank_card_payment(
            this.payment_constructor.amount,
            selected_fast_card.id
          );
          if (charge.done) {
            swal({
              type: "success",
              header: "Успешно!",
              html: "Меньше чем через минуту деньги будут зачислены.",
            });
          } else {
            swal({
              type: "error",
              header: "Ошибка быстрой оплаты",
              html: "Попробуйте ещё раз или обновите страницу.",
            });
            this.payment_constructor.loading = false;
            for (let c of this.payment_constructor.fast_bank_cards)
              c.selected = false;
          }
        } else {
          // просто оплата картой
          var bill = await apiDriver.payments.require_card_payment(
            this.payment_constructor.amount,
            save_card_payment
          );
          if (bill.done) {
            // this.openInNewTab(bill.pay.url);
            document.location.href = bill.pay.url;
            this.$modal.hide("payment_set_amount_window");
          } else {
            swal({
              type: "error",
              header: "Ошибка создания счёта",
              html: "Попробуйте ещё раз или обновите страницу.",
            });
          }
        }
      }
    },

    async payAsAdmin() {
      console.log("PAY AS ADMIN", this.payment_constructor, this);
      this.payment_constructor.loading = true;
      let done = await apiDriver.admin.users.addMoney(
        this.$store.state.userData.user.id,
        this.payment_constructor.amount,
        this.payment_constructor.amount_type,
        "From User's lk"
      );
      this.payment_constructor.loading = false;
      if (done) {
        this.$toast.success("Средства зачислены!");
        this.$modal.hide("payment_set_amount_window");
      } else {
        this.$toast.success("Произошла ошибка");
      }
      this.refresh_balances();
    },

    declOfNum(number, titles) {
      var cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    async getActs() {
      let acts = (await apiDriver.acts.get()).acts;
      for (let act of acts) {
        var dateStart = moment(act.data.dates[0])
          .add(1, "day")
          .format("YYYY.MM.DD");
        var dateEnd = moment(act.data.dates[1])
          .add(-1, "day")
          .format("YYYY.MM.DD");
        act.dateStart = dateStart;
        act.dateEnd = dateEnd;
      }
      this.acts = acts;
    },
  },
};

function declOfNum(number, titles) {
  var cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
}
</script>
<style scoped lang="stylus">
.red_transaction {
  color: #f44336;
}

.green_transaction {
  color: #4caf50;
}

.my-header {
  font-size: 26pt;
}

.header-sub {
  font-size: 1.5rem;
}

.account-money {
  font-weight: bold;
  font-size: 1.5rem;
  font-weight: normal;
  cursor: default;
}

.pay-submit-btn {
  cursor: pointer;
  color: #6c68cb;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  padding: 15px;
  // transition: all 0.3s ease;
  border: 1px solid #6c68cb;
  min-width: 100px;
  background: white;

  &:hover {
    background: #6c68cb;
    color: white;
  }

  i {
    position: relative;
    top: -3px;
    margin-left: 5px;
  }
}

.balance {
  .value {
    font-size: 12pt;
    font-weight: bold;
    margin-left: 5px;
  }
}

.table {
  background: white;
  padding: 10px;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 20px 70px rgba(0, 0, 0, 0.1);
}

.not_found {
  text-align: center;
  padding: 100px 0px;
  color: gray;
}

.row.transaction {
  border-bottom: 1px solid #eee;
  margin-bottom: 3px;
  width: 100%;
  margin: 0;
  padding: 5px 0px;
}

.row.transaction[operation='refill'] {
  color: #0e5a0e;
}

.row.transaction[operation='withdraw'] {
  color: #d01717;
}

.table {
  padding: 0px;

  .row {
    cursor: default;
    width: 100%;
    margin: 0;
    padding: 5px 0px;
  }

  &.multiple_rows {
    .row {
      border-bottom: 1px solid #eee;
      margin-bottom: 5px;
      padding-bottom: 5px;

      &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
      }
    }
  }
}

.spending {
  .month {
    text-transform: capitalize;
    font-size: 12pt;
    color: #000;
    cursor: default;
  }

  .year {
    font-size: 9pt;
    color: #a0a0a0;
  }
}

.message {
  margin-top: 10px;
  opacity: 0.7;
  display: none;
  cursor: default;

  &.show {
    display: block;
  }

  a {
    color: black;
  }
}

button {
  width: 100%;
  outline: none;

  &[disabled] {
    border-color: #eee !important;
    cursor: default !important;
    background: white !important;
    color: #ddd !important;
  }
}

.refill_window {
  position: absolute;
  margin-top: 0px;
  background: white;
  padding: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  width: 210px;
  z-index: 2;
  display: none;

  &.show {
    display: block;
  }
}

.refill_popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 1030;
  display: none;

  &.show {
    display: block;
  }

  h2 {
    margin-top: 50px;
  }
}

.v--modal-overlay {
  .container {
    height: 100%;

    .row {
      height: 100%;
    }
  }

  .content {
    height: calc(100% - 60px);
    position: relative;
    display: block;
  }

  .loader_holder {
    display: none;
  }

  &.loading {
    .loader_holder {
      display: block;
    }

    .content {
      display: none;
    }
  }

  h2 {
    margin-top: 10px;
    color: #484848;
    margin-bottom: 10px;
  }

  .label {
    color: #a7a7a7;
  }

  .value {
    margin-left: 5px;
  }

  .loader_holder {
    text-align: center;
  }

  &[data-modal='payment_set_amount_window'] {
    .payment_sum_input {
      padding: 5px 10px;
      border: none;
      outline: none;
      border-bottom: 1px solid #eee;
      font-size: 17pt;
      width: 100%;

      &:focus {
        border-color: #6c68cb;
      }
    }

    .select_card {
      position: absolute;
      bottom: 60px;

      .fast_card {
        border: 1px solid #eee;
        display: inline-block;
        border-radius: 4px;
        padding: 2px 9px;
        margin-top: 4px;
        font-weight: bold;
        cursor: pointer;
        color: #4c4c4c;
        margin-right: 5px;

        &:hover {
          border-color: #b3b3b3;
        }

        &.selected {
          border: 1px solid #6c68cb;
          color: #6c68cb;
        }
      }
    }

    .save_payment {
      position: absolute;
      bottom: 15px;

      .checkbox_label {
        position: relative;
        top: -2px;
        margin-left: 5px;
      }
    }

    button {
      position: absolute;
      bottom: 20px;
      right: 5px;
      margin-top: 0px;
      width: 150px;
      padding: 15px;
    }
  }
}

.set_payment_amount {
  .content {
    min-height: 250px;
  }

  .bonusRules {
    color: gray;
    margin-top: 10px;
    font-size: 10pt;

    .currentRule {
      font-weight: bold;
    }

    ul {
      margin-top: 5px;
    }

    margin-bottom: 85px;
  }
}

.success_payment {
  .bonusText {
    background: #4CAF50;
    padding: 5px 10px;
    border-radius: 8px;
    color: white;
    cursor: default;
    display: inline-block;
  }

  .amountText {
    font-size: 14pt;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: default;
    padding-left: 10px;
    border-left: 1px solid #eee;

    b {
      margin-left: 5px;
    }
  }

  .bonusRules {
    color: gray;
    margin-top: 10px;
    font-size: 10pt;

    .currentRule {
      font-weight: bold;
    }

    ul {
      margin-top: 5px;
    }
  }

  .close {
    position: absolute;
    top: 4px;
    right: 8px;
    z-index: 1;
  }
}

.refillBonus {
  background: #4CAF50;
  padding: 5px 10px;
  border-radius: 8px;
  color: white;
  cursor: default;
  display: inline-block;
  margin-top: 10px;
}

.act {
  .dates {
    color: gray;
    font-size: 9pt;
  }

  i {
    margin: 0 5px;
    font-size: 6pt;
    position: relative;
    top: -2px;
  }

  .download {
    margin-top: 5px;
  }
}

button.styled {
  margin: 4px 0;
}

@media only screen and (max-width: 600px) {
  .success_payment .amountText b {
    display: block;
  }

  .success_payment .bonusRules ul {
    padding-left: 15px;
  }

  .set_payment_amount .bonusRules ul {
    padding-left: 15px;
  }
}

@media (prefers-color-scheme: dark) {
  a {
    margin-left: 0;
  }

  .table {
    background: #161616;
    color: white;
  }

  .row.transaction {
    border-color: #3a3a3a;
  }

  .spending .month {
    color: white;
  }

  .table.multiple_rows .row {
    border-color: #3a3a3a;
  }

  .pay-submit-btn {
    background: #7975e6;
    color: white;
    border-color: #b0adff;
  }

  .refill_window {
    background: #2c2c2c;
  }

  .set_payment_amount .content {
    color: white;
  }

  .set_payment_amount .bonusRules {
    color: #b9b9b9;
  }

  button[disabled] {
    color: #525252 !important;
    background: #303030 !important;
    border-color: #525252 !important;
  }

  .message a {
    color: #fff;
    margin-left: 5px;
  }
}
</style>